function CCTProductsInfini(limit_per_page,page_param,
                           withRestaurants = false ,
                           handle="",template="card_products", type_list ="") {

    let host_url="https://filter.tiptoque.com/v1.0.0/aifred/marketplace/restaurants/"
    //let host_url="https://interface-chef.tiptoque.com/api/aifred"
    this.debugAiFredConnect = false
    //special debug
    if(window.Shopify.theme.role !=="main"){
        //this.debugAiFredConnect = false //sinon connection ngrok
        host_url="https://aifred-develop.tiptoque.com/v1.0.0/aifred/marketplace/restaurants/"
        //host_url="https://marmot-busy-privately.ngrok-free.app/v1.0.0/aifred/marketplace/restaurants/"
        this.debugAiFredConnect = host_url.includes("ngrok")
    }

    this.collection_url = host_url + "filters";
    this.url_count_filter =  host_url +"countfilters";

    this.type_list = type_list;
    this.handle = handle;
    this.template = template;
    this.withRestaurants= withRestaurants
    this.urlBase = window.location.pathname.split("?")[0] || ''
    this.params_filter={
        "page":"page=1",
        "page_param":"page_param="+page_param,
        "urlbase":"urlbase="+ this.urlBase,
        "limit":"limit="+limit_per_page
    }
     if(sessionStorage.getItem("filter_prod")){
        let paramsSessionStorage = JSON.parse(sessionStorage.getItem("filter_prod"))
        if(!!paramsSessionStorage[this.handle] && Object.values(paramsSessionStorage[this.handle]).length > 0){
          //  console.log({localcurrent:paramsSessionStorage[this.handle]})
            this.params_filter = paramsSessionStorage[this.handle]
        }
     }
    if(!!handle){
        this.params_filter['handle']="handle=" + handle
    }
    this.init();
}

CCTProductsInfini.prototype = {
    _:{
        selectors:{
        },
        messages: { }
    },
    emit:function(name){
        var colorBG = "#1e98ec"
        if(name==="productUnvalid"){
            colorBG = "red"
        }
        if(name==="productValid"){
            colorBG = "green"
        }
        console.log("%c→ EMIT CCTProductsInfini." + name,"background:"+colorBG+";color:#FFF")
        console.log({arguments})
        $(document).trigger('CCTProductsInfini.'+name,arguments);
    },
    changeSelectVariants(evt, name, data){
        evt.preventDefault();
        evt.stopPropagation();
        const selectElement = evt.currentTarget;
        //  const selectedValue = selectElement.value;
        const selectedIndex = selectElement.selectedIndex;
        const options = selectElement.options;
        const selectedOption = options[selectedIndex];
        let dataPrice = selectedOption.dataset.price;
        let pid = selectedOption.dataset.pid;
        let vid = selectedOption.dataset.vid;
        dataPrice =  new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(parseInt(dataPrice)/100)
        //  console.log({dataPrice,pid,vid})
        $('.js-product_card[data-pid='+pid+'] .js-product_price').html(dataPrice)
        $('.js-product_card[data-pid='+pid+'] .js-add_product').attr("data-variant",vid)
        //.html(vid) //.dataset.vid = vid
    },
    delay: async function(ms){
        return new Promise(resolve => setTimeout(resolve, ms))
    },
    addproductCart: async function(evt, name, data) {
        evt.preventDefault();
        evt.stopPropagation();
        const buttonElement = evt.currentTarget;
        buttonElement.setAttribute("disabled", true)
        buttonElement.style.opacity = 0.6
        const vid = buttonElement.dataset.variant.replace("gid://shopify/ProductVariant/","");

        let productCart = TT.getProduct(vid)
        let qty = 0;
        if (!!productCart) {
            qty = parseInt(productCart.quantity);
        }
        const vendor = buttonElement.dataset.vendor;

        //let vid =  $(selectElement).parent().find("select")
        let datas = {
            variant_id: vid,
            quantity: qty + 1,
            vendor: vendor,
            properties: {
                _originQuantity: qty,
                _vendor: vendor
            }
        };
        //  console.log(datas)

        let quantity = parseInt(TT.getQuantityForChange(datas))
        //    console.log(qty, quantity, vendor, vid)

        this.emit('changeProductQuantity', datas);

        if (TT.getCountProducts() === 0) {
            await this.delay(2000)
        }

        buttonElement.removeAttribute("disabled")
        buttonElement.style.opacity = 1
        if (qty > 0) {
            $(".js-drawer-open-cart").click()
        }
    },
    openFilterMobile: function(evt, name, data){
        $(".js-section_aside").addClass("active")
    },
    closeFilterMobile: function(evt, name, data){
        $(".js-section_aside").removeClass("active")
    },
    displayOtherProducts:function (evt, name, data){
        $(".js-button-more").addClass("hidden");
        $(".js-restaurant_paginate").removeClass("hidden");
        $(".js-product_card ").removeClass("hidden");
    },
    getCollection:async function(){
        if(this.collection_url ===""){
            return false
        }
        let params = ""
        if( Object.values(this.params_filter).length > 0){
            params = "?"+ Object.values(this.params_filter).join("&")
        }

        let url = this.collection_url+params
       //  console.log({url})

        let options= {
            headers:{
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-TIPTOQUE-AUTH-TOKEN":"3dfcb3274eb1f918a76cd97aee2a9e8b"
            },
            method: 'GET'}

        if(this.debugAiFredConnect){
            options.headers["ngrok-skip-browser-warning"] = true
        }

        this.collection =  await fetch(url , options)
            .then(response => response.json())
        return this.collection
    },
    getCountFilters:async function(){
        if(this.url_count_filter ===""){
            return false
        }
        let params = ""
        if( Object.values(this.params_filter).length > 0){
            params = "?"+ Object.values(this.params_filter).join("&")
        }
        let url = this.url_count_filter+params
        //  console.log({url})
         let options= {
            headers:{
                //  "ngrok-skip-browser-warning":true,
                "Accept": "application/json",
                "Content-Type": "application/json",
                "X-TIPTOQUE-AUTH-TOKEN":"3dfcb3274eb1f918a76cd97aee2a9e8b"
            },
            method: 'GET'}

        if(this.debugAiFredConnect){
            options.headers["ngrok-skip-browser-warning"] = true
        }
        return  await fetch(url , options)
            .then(response => response.json())

    },

    //-- afficher le nombre de produit en fonction de la collection
    renderFilterCountProduct:async function(){
        
        console.log("renderFilterCountProduct")
        // console.log({collection})
        let filters = await this.getCountFilters()
        //console.log({filters})
        for (let tag in filters.totals) {
            let count_resto = filters.totals[tag].count_restaurants
            let element_count = $('.js-filter_count[data-tag="'+tag+'"]')
            if(element_count.length){
                element_count.html("("+count_resto+")")
            }
        }
    },
    saveParamsSessionStorage(handle, datas){
        //save mes nouveau filtre dans le localstorage pour le trie
        let paramsSessionStorage = JSON.parse(sessionStorage.getItem("filter_prod")) || {}
        paramsSessionStorage[handle]=datas
        sessionStorage.setItem("filter_prod", JSON.stringify(paramsSessionStorage))
    },
    // change le filtre ou le trie
    selectSortBy:async function(evt, name, data){
        //  this.params_filter["page"]="page=1"
        let sortElement = evt.currentTarget
        let sortBy = sortElement.value
        if(!this.params_filter['sort_by']){
            this.params_filter['sort_by']=[]
        }
        this.params_filter['sort_by']="sort_by=" + sortBy

        this.saveParamsSessionStorage(this.handle,this.params_filter)

        if(sortBy === "" && !!this.params_filter['sort_by']){
            delete this.params_filter['sort_by']
            $(".js-button-sort").each(function() {
                this.selectedIndex = 0;
            });
        }
        //  console.log({params_filter:this.params_filter})
        await this.renderProductWithFilterSort()
    },
    checkboxFilterTags:async function(evt, name, data){
        

        if(!!evt){
            $('html,body').scrollTop($('.js-section_restaurants').offset().top - 200);
        }

        this.params_filter["page"]=this.params_filter["page"] || "page=1"
        let filters=[]
        let paramsTags=[]
        $(".js-filter_tag").each((index,el)=>{
            el.disabled = true;
            if(el.checked){
                paramsTags.push(el.dataset.tag)
                filters.push({tag : el.dataset.tag,checked:el.checked})
            }
        })

        if(!this.params_filter['filter.p.tag']){
            this.params_filter['filter.p.tag']=[]
        }

        if(paramsTags.length > 0){
            this.params_filter['filter.p.tag']="filter.p.tag=" + paramsTags.join(',')
        }

        // supprimer tous les filtres si y a pas de tags selectionner
        if(!!evt){
            if(!!this.params_filter['filter.p.tag'] && paramsTags.length === 0){
                delete this.params_filter['filter.p.tag']
                if(!!this.params_filter['sort_by']){
                    delete this.params_filter['sort_by']
                    $(".js-button-sort").each(function() {
                        this.selectedIndex = 0;
                    });
                }
            }
        }

        //save mes nouveau filtre dans le localstorage pour les tags
        this.saveParamsSessionStorage(this.handle,this.params_filter)
      //  console.log("checkboxFilterTags")
        await this.renderProductWithFilterSort()
        await this.renderFilterCountProduct()

        $(".js-filter_tag").each((index,el)=>{
            el.disabled = false;
        })
        //remùove tous les produits puis ajout du loader et ajouter les prodduit recuperer sur le json collection


    },

    // click sur la paginationation le gerer que si et seulement si y a des filtre et tire
    clickProductPaginate:async function(evt, name, data){
      //  console.log(this.params_filter)

        $('html,body').scrollTop(0);
        evt.preventDefault();
        evt.stopPropagation();
        //relancer la recuperation de la colletion et on change la page
        let linkEl = evt.currentTarget
        this.params_filter["page"]="page="+linkEl.dataset.page

        //save mes nouveau filtre dans le localstorage pour le num page

        this.saveParamsSessionStorage(this.handle,this.params_filter)
        await this.renderPaginate()
       
    },
    //changer la pagination en fonction de la collection
    renderPaginateFilterSort(){
        if(!this.templatePagionateTmp){
            $(".js-restaurant_paginate").removeClass("skeleton_paginate");
            this.templatePagionateTmp =  $(".js-restaurant_paginate").html()
        }
        //$(".js-restaurant_paginate").removeClass("hidden");
    //    console.log(this.collection)
        if( this.collection['paginate']['pages'] > 1){
            $(".js-restaurant_paginate").removeClass("skeleton_paginate");
            $(".js-restaurant_paginate").html(`<div class="links_paginate">${this.collection['paginate_html']}</div>`)
        }else{
            $(".js-restaurant_paginate").html("")
        }
    },
    renderPaginateBase: async function(){
        let filters = await this.getCountFilters()
      //  console.log(filters)
        // this.templatePagionateTmp =  filters
        if( filters['paginate']['pages'] > 1){
            $(".js-restaurant_paginate").removeClass("skeleton_paginate");
            $(".js-restaurant_paginate").html(`<div class="links_paginate">${filters["paginate_html"]}</div>`)
        }else{
            $(".js-restaurant_paginate").html("")
        }
    },
    renderPaginate: async function(){
      //  console.log("renderPaginate ")
        if(Object.keys(this.params_filter).includes("sort_by") ||
            Object.keys(this.params_filter).includes("filter.p.tag")
            ){
          //      console.log("Paginate WithFilterSort ")
                await this.renderProductWithFilterSort()
            }else{
         //       console.log("Paginate Base ")
                await this.renderPaginateBase()
            }
    },

    //------ GENERATEUR DE CARTE PRODUITS EN FNCT DES FILTRES ET TIRES
    renderProductWithFilterSort:async function() {
        if(this.collection_url ===""){
            return false
        }
        $('.js-button-sort').removeClass("hidden");
        //si pas de filtre ou de sort ... retour a la normal grace au tmp
        // this.templateTmp

        //TODO revoir si pas de filtre pour rendre les produit avec l ensemble des produits
        if(false && !this.params_filter["filter.p.tag"] && !this.params_filter["sort_by"]){
            $(".js-section_restaurants").html(this.templateSectionTmp)
            $(".js-restaurant_paginate").html(this.templatePagionateTmp)
            return true
        }

        //recuperer la collection avec les filtre et le trie
        await this.getCollection()

        //initialiser la page si utiliser
        //console.log({collection: this.collection, url: window.location.pathname.split("?")})
        window.history.pushState({}, "", this.urlBase)

        //enlever tous les restaurants
        if(!this.templateSectionTmp){
            this.templateSectionTmp =  $(".js-section_restaurants").html()
        }
        if(this.template =="card_restaurants"){
            $(".js-section_restaurants_list").html("")
        }else if(this.template =="card_products"){
            $(".js-section_restaurants").html("")
        }

        //charger le nouveau pagination.. en fonction du clique
        // celui la sera update faire fonction pour ca
        if(! this.withRestaurants){
            await  this.renderPaginateFilterSort()
            for (let product of this.collection.products) {
                // console.log({product})
                $(".js-section_products_list").append(product.card)
            }
        }else{
            //generer la pagination
            await this.renderPaginateFilterSort()
            //format de la liste est ajouter dans js-section_restaurants
            // class  restaurant_info
            let templateRestaurants = "";
            //difference de template
            if(this.template =="card_restaurants"){
                templateRestaurants = this.template_restaurants_card(templateRestaurants)
            }else if(this.template =="card_products"){
                templateRestaurants = this.template_restaurants_products(templateRestaurants)
            }
            if(templateRestaurants === ''){
                $('.js-button-sort').addClass("hidden");
                templateRestaurants = `<div class="section_no_result"><p> Malheureusement nous n'avons pas encore d'offres répondant à votre demande. <a href="/" style="text-decoration: underline;font-weight: bold">Revenir à la page d'accueil.</a></p></div>`
            }
            if(this.template =="card_restaurants"){
                $(".js-section_restaurants_list").append(templateRestaurants)
            }else if(this.template =="card_products"){
                $(".js-section_restaurants").append(templateRestaurants)
            }
        }
    },
    template_restaurants_card:function(){
        let templateRestaurants = "";
        for (var restaurant of this.collection.restaurants.datas) {
            let templateRestaurant = $('#js-template_card_restaurant').html();

            templateRestaurant = templateRestaurant.split("%_r.img.src_%").join(restaurant.page_hero_image)

            templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant/"+restaurant.handle)

            templateRestaurant = templateRestaurant.split("%_r.name_%").join(restaurant.name)
            templateRestaurant = templateRestaurant.split("%_r.chef_%").join(restaurant.chef_name||'')
            let adresse = restaurant.address+`<br/>`+restaurant.zip+" "+restaurant.city

            if(restaurant.city.includes("Paris") ){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Paris"
            }
            if(restaurant.city.includes("Marseille")){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Marseille"
            }
            if(restaurant.city.includes("Lyon")){
                adresse = restaurant.address+`<br/>`+restaurant.zip+" Lyon"
            }

            templateRestaurant = templateRestaurant.split("%_r.address_%").join(adresse)
            let offres = ""
            for (var key in restaurant.offre_names) {
                let offre_restaurant = restaurant.offre_restaurant[key]
                 let offre_ancre = restaurant.offre_ancres[key]
                if(!restaurant.offre_ancres[key]){
                    offre_ancre = ''
                }
                if(!restaurant.offre_restaurant[key]){
                    offre_restaurant = "restaurant"
                }

                if(restaurant.restaurantlist_handle[key] !== null){
                   // if(restaurant.offre_ancres[key] !== null){
                        offres += `<a href="/pages/${offre_restaurant}/${restaurant.handle}${offre_ancre}" class="restaurant_offre">${restaurant.offre_names[key]}</a>`
                  //  }
                    //offres += `<a href="/pages/liste/${restaurant.restaurantlist_handle[key]}" class="restaurant_offre">${restaurant.offre_names[key]}</a>`
                }else{
                    offres += `<span class="restaurant_offre">${restaurant.offre_names[key]}</span>`
                }
            }
            templateRestaurant = templateRestaurant.split("%_r.offres_%").join(offres)
            let distinctions_html =''
            if(!!restaurant.michelin_distinction){
                let distinctions = !!restaurant.michelin_distinction && (restaurant.michelin_distinction).includes(",")?restaurant.michelin_distinction.split(","):[restaurant.michelin_distinction]
                //  console.log({name:restaurant.name,michelin_distinction:restaurant.michelin_distinction,distinctions})
                for (var distinction of distinctions) {
                    let current = window.distinction_icons[distinction]||null
                    //  console.log({n:restaurant.name,current,distinction,distinction_icons:window.distinction_icons})
                    if(!!current){
                        let count_image = current.count
                        let icon = current.icon.repeat(count_image)
                        distinctions_html += icon
                    }
                }
            }
            templateRestaurant = templateRestaurant.split("%_r.distinction_icons_%").join(distinctions_html)

            templateRestaurants +=templateRestaurant
        }
        return templateRestaurants
    },
    template_restaurants_products:function(){
        let templateRestaurants = "";
        //generer les restaurants avec les produits
        //recuperer les templacte restaurant solo
        //recuperer le template produit solo
        // boucler avec les informations recuperer avec api pour le generer
        //  console.log({collectiondata:this.collection.restaurants.datas})
        for (var restaurant of this.collection.restaurants.datas) {
            //  console.log({restaurant})
            let templateRestaurant = $('#js-template_section_restaurant').html();
            templateRestaurant = templateRestaurant.split("%_r.name_%").join(restaurant.name)
            
            
            
            templateRestaurant = templateRestaurant.split("%_r.city_%").join(restaurant.city)
         
           // console.log({template:this.template, handle:this.template.handle,restaurant})
            if(this.handle === "les-cours-de-cuisines" || this.type_list === "cc_cours_cuisine_localite"){
                templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant-cours-de-cuisine/"+restaurant.handle+"#cours-de-cuisine")
            }else{
                templateRestaurant = templateRestaurant.split("%_r.url_%").join("/pages/restaurant/"+restaurant.handle+"#cartes_cadeaux")
            }

            //   templateRestaurant = templateRestaurant.split("%_r.city.url_%").join("/pages/villes/"+restaurant.city_handle)
            let distinctions_html =''
            if(!!restaurant.michelin_distinction){
                let distinctions = !!restaurant.michelin_distinction && (restaurant.michelin_distinction).includes(",")?restaurant.michelin_distinction.split(","):[restaurant.michelin_distinction]
                //  console.log({name:restaurant.name,michelin_distinction:restaurant.michelin_distinction,distinctions})
                for (var distinction of distinctions) {
                    let current = window.distinction_icons[distinction]||null
                    //  console.log({n:restaurant.name,current,distinction,distinction_icons:window.distinction_icons})
                    if(!!current){
                        let count_image = current.count
                        let icon = current.icon.repeat(count_image)
                        distinctions_html += icon
                    }
                }
            }

            // console.log({distinctions_html})
            templateRestaurant = templateRestaurant.split("%_r.distinction_icon_%").join(distinctions_html)


            let note_vote=!restaurant.rating_value ? null : (restaurant.rating_value* 0.1).toFixed(1)

            let templateProducts = ''
            for(var product of restaurant.products ){

                let templateProduct =  $('#js-template_card_product').html();
                templateProduct = templateProduct.split("%_p.id_%").join(product.shopify_products_id)
                templateProduct = templateProduct.split("%_v.first.id_%").join(product.variants.data[0].id)
                templateProduct = templateProduct.split("%_p.url_%").join("/products/"+product.shopify_handle)//pas url du produit

                let image = product.images || ''
                if(!!product.images && product.images.includes(",")){
                    image=product.images.split(",")[0]
                }

                templateProduct = templateProduct.split("%_p.img.src_%").join(image)

                let title_product = product.shopify_title
                if(title_product.includes("__")){
                    title_product =  title_product.split("__").join(",")
                }
                if(title_product.includes("||")){
                    title_product =  title_product.split("||").join("&")
                }

                //console.log({lenNameR:title_product.length,name:title_product})
                let title_product_truncate = title_product.length > 60 ? title_product.slice(0, 60) + "..." : title_product;
                templateProduct = templateProduct.split("%_p.title_truncate_%").join(title_product_truncate)
                templateProduct = templateProduct.split("%_p.title_%").join(title_product)

                let vote_stars = ""

                
                if( !!product.shopify_tags && product.shopify_tags.includes("NOTE|")){
                    let tags =product.shopify_tags.includes(", ") ? product.shopify_tags.split(", ") : [product.shopify_tags]
                    note_vote  = (tags.filter((el)=>el.includes("NOTE|"))[0].split("|")[1] * 0.1).toFixed(1)
                }

                if(note_vote !== null){
                    vote_stars+=`<div class="product_note"><div class="product_note_txt">${ note_vote}</div>`
                    let note_full = Math.floor(note_vote)
                    let is_half = note_vote - note_full
                    for (let i = 1; i <= note_full; i++) {
                        vote_stars+=`<div class="note_icon note_full"></div>`
                    }
                    if( is_half >=0.5){
                        vote_stars+=`<div class="note_icon note_half"></div>`
                        note_full = note_full + 1
                    }
                    let note_empty = 5 - note_full
                    for (let i = 1; i <= note_empty; i++) {
                        vote_stars+=`<div class="note_icon note_empty"></div>`
                    }
                    vote_stars+=`<div class="note_icon note_info noteinfo js_note_info_txt"></div>`
                    vote_stars+=`<div class="note_info_txt js_note_info_txt">Moyenne des avis <br/> clients pour ce restaurant.</div>`
                    vote_stars+=`</div>`

                }

                templateProduct = templateProduct.split("%_p.vote_%").join(vote_stars)

                templateProduct = templateProduct.split("%_p.handle_%").join(product.shopify_title)
                templateProduct = templateProduct.split("%_p.type_%").join(product.shopify_product_type)
                templateProduct = templateProduct.split("%_p.tags_%").join(product.shopify_tags)
                templateProduct = templateProduct.split("%_p.vendor_%").join(product.shopify_vendor)

                templateProduct = templateProduct.split("%_r.name_%").join(restaurant.name+" - "+restaurant.city)
                templateProduct = templateProduct.split("%_p.distinction_icons_%").join(distinctions_html)

                let variant_title = ''
                if(!!product.variants.data[0].title){
                    variant_title = product.variants.data[0].title
                }else if(!!product.variants.data[0].option1){
                    variant_title = product.variants.data[0].option1
                }

                let vmulti_price =''
                if(product.variants.data.length > 0 && !variant_title.includes('€') && !variant_title.includes('Default') ){
                    vmulti_price=`<div class="product_price js-product_price" data-pid="${product.shopify_products_id}" >${parseFloat(product.variants.data[0].price).toFixed(2).split(".").join(',')} €</div>`
                }
                templateProduct = templateProduct.split("%_v.multi.price_%").join(vmulti_price)

                let vmulti_select =''
                if(product.variants.data.length > 0){
                    if(product.variants.data.length > 1){
                        vmulti_select+=`<select class="js-select-product">`
                        for (var variant of product.variants.data) {
                            if(!!variant.id){
                                vmulti_select+=`<option  data-vid="${ variant.id}"
                                                 data-pid="${ product.shopify_products_id}"
                                                 data-price="${parseFloat(variant.price)*100}" >${variant.title || variant.option1}</option>`
                            }else{
                                vmulti_select+=`<!-- ERROR pas vid bdd-->`
                            }
                        }
                        vmulti_select+=`</select>`
                    }else{
                        if(!variant_title.includes('€') && !variant_title.includes('Default')  ){
                            vmulti_select=`${variant_title}`
                        }else{
                            vmulti_select=`<div class="product_price js-product_price" data-pid="${product.shopify_products_id}" >${parseFloat(product.variants.data[0].price).toFixed(2).split(".").join(',')} €</div>`
                        }
                    }
                }

                templateProduct = templateProduct.split("%_v.select.price_%").join(vmulti_select)

                if(!!product.variants.data[0].id || this.DEBUGLOG){
                    if(!product.variants.data[0].id){
                        console.error("le produit id= "+product.id+" - le restaurant id= "+restaurant.id+"  - "+restaurant.name+" "+product.shopify_title+" n as pas de variant id dans la bdd ")
                        templateProduct = templateProduct.split("%_ERROR_%").join("error")
                    }else{
                        templateProduct = templateProduct.split("%_ERROR_%").join("")
                    }
                    templateProducts+=templateProduct
                }else{
                    console.error("le produit id= "+product.id+" - le restaurant id= "+restaurant.id+"  - "+restaurant.name+" "+product.shopify_title+" n as pas de variant id dans la bdd ")
                }
            }
            if(templateProducts !== "" ){
                templateRestaurants += templateRestaurant.split("%_r.product_cards_%").join(templateProducts)
            }

        }
        return templateRestaurants
    },
    clearSessionStorage:async function(){


    },
    initFilterTagsBySessionStorage:async function(){
        //this.params_filter['filter.p.tag']
        //filter.p.tag=DISTINCTION|2_STARS,DISTINCTION|GREEN_STAR,PRICE_RANGE|EURO_3,REGIONS|AR
        if(!!this.params_filter['sort_by']){
            let filter_sort = this.params_filter['sort_by'].split("sort_by=").join('')
         //   console.log({filter_sort})
            $(".js-button-sort").val(filter_sort);
            console.log("initFilterTagsBySessionStorage sort_by")
            if(!this.params_filter['filter.p.tag']){
                await this.renderFilterCountProduct();
                await this.renderPaginate()
            }
        }

        if(!!this.params_filter['filter.p.tag'] && this.params_filter['filter.p.tag'].length >0){
            let filter_tags=  this.params_filter['filter.p.tag'].split('filter.p.tag=').join('')
            filter_tags=  filter_tags.split(',')
            for (var filterTag of filter_tags) {
                  $(".js-filter_tag[data-tag='"+filterTag+"']").attr('checked','checked')
            }
            console.log("initFilterTagsBySessionStorage filter.p.tag")
            await this.renderFilterCountProduct();
            await this.renderPaginate()
            //TODO faire pour la pagination et pour le trie
        }
    },
    init:async function () {
        this.DEBUGLOG = false
        console.log("%cSTART CCT.Products-Infini", "background:cyan;color:#333")
        this.bindEvents();
        await this.initFilterTagsBySessionStorage();
        await this.checkboxFilterTags();
        //   await this.getCollection();
        if( this.url_count_filter !==""){
            console.log("init ")
            await this.renderFilterCountProduct();
            await this.renderPaginate()
        }
        //relance le checkbox filter si retour avec le bouton precedent du naviguateur

    },



    triggerNoteInfoTxt:async function(evt, name, data){
        const currentElement = evt.currentTarget;
        document.querySelectorAll('.js_note_info_txt').forEach(element => {
            if (element !== currentElement && element !== currentElement.nextElementSibling) {
            element.classList.remove('active');
            }
        });
       
        let noteInfoTxt =evt.currentTarget;
        if (evt.currentTarget.classList.contains("noteinfo")) {
            noteInfoTxt = evt.currentTarget.nextElementSibling;
        } 
        console.log({noteInfoTxt})
        evt.preventDefault();
        evt.stopPropagation();
        if(noteInfoTxt.classList.contains("active")){
            noteInfoTxt.classList.remove("active")
        }else{
            noteInfoTxt.classList.add("active")
        }
    },
    bindEvents:function(){

        $("body")
            .off("change.button_sort").on("change.button_sort", ".js-button-sort",_.bind(this.selectSortBy, this))
            .off("click.product_paginate").on("click.product_paginate", ".js-restaurant_paginate a",_.bind(this.clickProductPaginate, this))
            .off("click.filter_tag").on("click.filter_tag", ".js-filter_tag",_.bind(this.checkboxFilterTags, this))
            .off("click.button-more").on("click.button-more", ".js-button-more",_.bind(this.displayOtherProducts, this))
            .off("change.select-product").on("change.select-product", ".js-select-product",_.bind(this.changeSelectVariants, this))
            .off("click.add_product_cart").on("click.add_product_cart", ".js-add_product",_.bind(this.addproductCart, this))
            .off("click.open_filtre").on("click.open_filtre", ".js-btn-filtre-open",_.bind(this.openFilterMobile, this))
            .off("click.close_filtre").on("click.close_filtre", ".js-btn-filtre-close",_.bind(this.closeFilterMobile, this))
            .off("click.trigger_note_info_txt").on("click.trigger_note_info_txt", ".js_note_info_txt",_.bind(this.triggerNoteInfoTxt, this))

        /*
          $(document)
              .on('TT.filtersValidated', _.bind(this.render, this))
              .on('TT.clearCart',_.debounce( _.bind(this.render, this), TT._.debounceTimeValue))
              .on('TT.removeTTProducts',_.debounce( _.bind(this.removeTTProducts, this), TT._.debounceTimeValue))
              .on('TT.itemCartUpdated', _.bind(this.synchronizeProductsDisplay, this))
              .on('TT.refreshQty', _.bind(this.synchronizeProductsDisplay, this))
              .on('TT.openBtnQty',_.bind(this.openBtnQty,this))
        */
    }
}

console.log("%cRENDER CCT.Products-Infini","background:yellow;color:#333")

